import { render, staticRenderFns } from "./PayfactoSupportUrl.vue?vue&type=template&id=b602aba6"
import script from "./PayfactoSupportUrl.vue?vue&type=script&lang=js"
export * from "./PayfactoSupportUrl.vue?vue&type=script&lang=js"
import style0 from "./PayfactoSupportUrl.vue?vue&type=style&index=0&id=b602aba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports